import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#004C97] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="mb-6">
              <div className="bg-white inline-block p-3 rounded-lg">
                <Logo />
              </div>
            </div>
            <p className="text-[#D4EDF7] mb-4 leading-relaxed">
              Innovation That Protects the Future
            </p>
            <p className="text-sm text-gray-300 leading-relaxed">
              Randovate Labs is a dynamic and forward-thinking company specializing in IT and business consulting services for the insurance domain.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#D4EDF7] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#D4EDF7] transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-[#D4EDF7] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#D4EDF7] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-6">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-[#D4EDF7] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300">Kuala Lumpur, Malaysia</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#D4EDF7] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300">aseem@randovatelabs.com</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#D4EDF7] mt-1 flex-shrink-0" />
                <span className="text-sm text-gray-300">+60 11 2170 0240</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#003366] mt-12 pt-8 text-center">
          <p className="text-sm text-gray-300">
            © {new Date().getFullYear()} Randovate Labs. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;